const foreign_worker_group_modal = {
  title: "Add Foreign Worker Profiles to this Group",
  headerText: "Select the profiles below that you want to add to this group.",
  saveBtnText: "Add to Group",
};

export default foreign_worker_group_modal;
